import { h, defineComponent } from 'vue';
// @ts-ignore
import { BTable } from 'buefy/dist/esm/table';
import { SortDirection } from '@/ui/types';
import { NothingToDisplayMessage } from '../message/NothingToDisplayMessage';

interface AnalyticsTableProps {
  list: BaseEntity[]; // makes sure we have at least an ID and title
  sort: string;
  dir: SortDirection;
  perPage?: number;
  paginated?: boolean;
  backendPagination: boolean;
}

export const AnalyticsTable = defineComponent<AnalyticsTableProps>({
  name: 'AnalyticsTable',
  props: ['list', 'groupTitle', 'sort', 'dir', 'perPage', 'paginated', 'backendPagination'],
  setup(props, context) {
    return function render() {
      return h(BTable, {
        ref: 'table',
        props: {
          data: props.list,
          backendSorting: true,
          backendPagination: props.backendPagination ?? true,
          backendFiltering: true,
          defaultSortDirection: 'asc', // not working with backendSorting
          defaultSort: [props.sort, props.dir], // not working with backendSorting
          sortIcon: 'angle-up',
          iconPack: 'far',
          perPage: props.perPage,
          paginated: props.paginated,
        },
        scopedSlots: {
          empty: () => h(NothingToDisplayMessage),
        },
        on: { sort: (field: string, dir: string) => context.emit('sort', field, dir) },
      }, [
        (context.slots.default)
          ? [context.slots.default()]
          : null,
      ]);
    };
  },
});
